import { useTranslation } from "react-i18next";

export function ArticleSectionDisclaimer() {
  const { t } = useTranslation();

  return (
    <section
      data-gtm-section="editorial"
      data-gtm-order="13"
      className="pt-6 mb-12"
    >
      <div className="text-sm text-secondary-bluegrey-5">
        {t(
          "This content is a summary (possibly assisted by AI) of the original source article, provided for informational purposes. It may contain simplifications or errors. For any clinical or research application, you must refer to the full source document, available in the Source tab."
        )}
      </div>
    </section>
  );
}
